import { helpers, required } from '@vuelidate/validators'

import DatetimePickerFieldPlugin from '@/features/settingsManagement/fieldManagement/edit/plugin/datetimePickerFieldPlugin/DatetimePickerFieldPlugin.vue'
import DatetimePickerFieldPluginValueRenderer from '@/features/settingsManagement/fieldManagement/edit/plugin/datetimePickerFieldPlugin/DatetimePickerFieldPluginValueRenderer.vue'

export const datetimePickerFieldPlugin = {
  type: 'datetime-picker',
  component: DatetimePickerFieldPlugin,
  valueRenderer: DatetimePickerFieldPluginValueRenderer,
  defaultExtraData: {
    placeholder: 'Select...',
  },
  getValidations({ props }) {
    const field = props.field
    const rules = {}
    const key = field.key

    const isRequired =
      typeof props.externalRequired === 'boolean' ? props.externalRequired : field.isCompulsory
    if (isRequired) {
      const message = `${key} is required`
      rules.required = helpers.withMessage(message, required)
    }

    return rules
  },
}
